<ngx-smart-modal
  #confirmationModal
  identifier="confirmationModal"
  (onAnyCloseEvent)="confirmService.respond()"
  [ui-add-title-to]="uiAddTitleOptions"
  [dismissable]="confirmOptions.dismissable"
  [escapable]="confirmOptions.escapable"
  [closable]="confirmOptions.closeable"
  [customClass]="confirmOptions.customClass"
>
  <div *ngIf="confirmationModal.hasData()">
    <header class="modal-header">
      <div class="modal-title">{{ confirmationModal.getData()?.titleModal | translate }}</div>
    </header>
    <div class="modal-body">
      <ng-container *ngIf="confirmOptions.supportHTMLContent; else elseMessageTemplate">
        <div [innerHTML]="confirmationModal.getData()?.message"></div>
      </ng-container>
      <ng-template #elseMessageTemplate>
        {{ confirmationModal.getData()?.message | translate }}
      </ng-template>
      <div class="confirm-button-wrapper mt-5">
        <ui2-button class="button-secondary-alt mr-3 {{ selectedButton ? 'disabled' : '' }}" (clicked)="confirmService.setResponse()">
          {{ confirmationModal.getData()?.labelCancel | translate }}
        </ui2-button>
        <div class="multi-button-wrapper mr-3" *ngFor="let confirmButton of confirmationModal.getData()?.confirmButtons">
          <ui2-button
            class="button-semantic {{ confirmButton.class }}"
            [ngClass]="{
              'button-loader': selectedButton && confirmButton.id === selectedButton,
              disabled: selectedButton && confirmButton.id !== selectedButton
            }"
            (clicked)="confirmService.setResponse(confirmButton.id)"
          >
            <span>{{ confirmButton.label | translate }}</span>
            <ui-loader class="loader-ng-select show-when-loading" *ngIf="selectedButton && confirmButton.id === selectedButton"></ui-loader>
          </ui2-button>
        </div>
      </div>
    </div>
  </div>
</ngx-smart-modal>
